// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  margin-right: 10px;
}
BODY {
	BACKGROUND-IMAGE: url('image001.8db8512b58cbfc9b.jpg'); FONT-FAMILY: Arial, Verdana, Helvetica
}



.mat-mdc-radio-button .mat-radio-ripple {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    pointer-events: none;
    border-radius: 50%;
}
.mat-ripple:not(:empty) {
    transform: translateZ(0);
}
.mat-mdc-focus-indicator {
    position: relative;
}
.mat-ripple {
    overflow: hidden;
    position: relative;
}
user agent stylesheet
div {
    display: block;
}
.mdc-radio__native-control {
    --mdc-radio-state-layer-size: 40px;
    font-weight: bold;
  }



  .mat-mdc-radio-button .mdc-form-field {
      margin-left: 40px;
      margin-right: auto;
      padding-left: 400px;
      padding-right: 0;
      order: 0;
      font-weight:400px;
  }

mat-option
{
  font-size: 20px;
}

mat-mdc-card
{
    margin-left: 0;
    margin-right: auto;
    padding-left: 4px;
    padding-right: 0;
    font-size: 40px;
    font-weight: bold;
}



.example-button-row button,
.example-button-row a {
  margin-right: 8px;
}
body{
  margin: 0px;
}
h2 {
  font-size: 1.5em;
  background-color: #ccc;
  margin: 20px;
  padding: 40px;
}

.h2-checkbox {
  font-size: 20px;
  font-weight: bold;
  font-style: italic;

}
.h2-tect {
  font-size: 20px;
}
.h2-tect-1 {
  font-size: 20px;
  vertical-align: middle;
  padding: 0cm;
}

.example-viewport {
  height: 100px;
  width: 350px;
  border: 1px solid black;
}

.example-item {
  height: 20px;
}


.example-dt {
  height: 30px;
  font-weight: bold;
  font-family: 'Courier New', Courier, monospace;
  font-size: large;
}

.example-dd {
  height: 30px;
}

.statOK{
 background-color:forestgreen;
}

.statKO{
  background-color:rgb(182, 13, 27);
 }
 .switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
  margin-left: 150px;
  margin-top: -50px;
}


.disabled {
  color: rgba(0, 0, 0, 0);
}

.enabled {
  color: rgba(0, 0, 0, 255);
}

.switch input {display:none; background-color: #ccc;}

.slider {
  position: absolute;
  cursor: pointer;
  top: -15px;
  left: 0;
  right: 0;
  bottom: 0;
   background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 0px;
   right: 0px;
  bottom: -3px;
  background-color: #2196F3;
  transition: .4s;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

#codeAbo{
  height: 30px;
  font-size: 20px;
 }

.ref{
  height: 30px;
  font-size: 20px;
 }

 .mat-chip-list-wrapper {
  flex-wrap: nowrap;
  overflow-x: auto;
}

.image-clignote  {
  animation-duration: .8s;
  animation-name: clignoter;
  animation-iteration-count: infinite;
  transition: none;
}
@keyframes clignoter {
 0%   { opacity:1; }
 40%   {opacity:0; }
 100% { opacity:1; }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;CACC,sDAAmC,EAAE;AACtC;;;;AAIA;IACI,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,iBAAiB;EACnB;;;;EAIA;MACI,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,QAAQ;MACR,iBAAiB;EACrB;;AAEF;;EAEE,eAAe;AACjB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;;AAIA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;AAEpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;EACE,iCAAiC;CAClC;CACA;EACC,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe,YAAY,EAAE,sBAAsB,CAAC;;AAEpD;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,SAAS;GACR,sBAAsB;EAEvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;GACR,UAAU;EACX,YAAY;EACZ,yBAAyB;EAEzB,eAAe;AACjB;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;CAChB;;AAED;EACE,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;CACC,OAAO,SAAS,EAAE;CAClB,OAAO,SAAS,EAAE;CAClB,OAAO,SAAS,EAAE;AACnB","sourcesContent":["mat-form-field {\r\n  margin-right: 10px;\r\n}\r\nBODY {\r\n\tBACKGROUND-IMAGE: url(image001.jpg); FONT-FAMILY: Arial, Verdana, Helvetica\r\n}\r\n\r\n\r\n\r\n.mat-mdc-radio-button .mat-radio-ripple {\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n    border-radius: 50%;\r\n}\r\n.mat-ripple:not(:empty) {\r\n    transform: translateZ(0);\r\n}\r\n.mat-mdc-focus-indicator {\r\n    position: relative;\r\n}\r\n.mat-ripple {\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\nuser agent stylesheet\r\ndiv {\r\n    display: block;\r\n}\r\n.mdc-radio__native-control {\r\n    --mdc-radio-state-layer-size: 40px;\r\n    font-weight: bold;\r\n  }\r\n\r\n\r\n\r\n  .mat-mdc-radio-button .mdc-form-field {\r\n      margin-left: 40px;\r\n      margin-right: auto;\r\n      padding-left: 400px;\r\n      padding-right: 0;\r\n      order: 0;\r\n      font-weight:400px;\r\n  }\r\n\r\nmat-option\r\n{\r\n  font-size: 20px;\r\n}\r\n\r\nmat-mdc-card\r\n{\r\n    margin-left: 0;\r\n    margin-right: auto;\r\n    padding-left: 4px;\r\n    padding-right: 0;\r\n    font-size: 40px;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n\r\n.example-button-row button,\r\n.example-button-row a {\r\n  margin-right: 8px;\r\n}\r\nbody{\r\n  margin: 0px;\r\n}\r\nh2 {\r\n  font-size: 1.5em;\r\n  background-color: #ccc;\r\n  margin: 20px;\r\n  padding: 40px;\r\n}\r\n\r\n.h2-checkbox {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  font-style: italic;\r\n\r\n}\r\n.h2-tect {\r\n  font-size: 20px;\r\n}\r\n.h2-tect-1 {\r\n  font-size: 20px;\r\n  vertical-align: middle;\r\n  padding: 0cm;\r\n}\r\n\r\n.example-viewport {\r\n  height: 100px;\r\n  width: 350px;\r\n  border: 1px solid black;\r\n}\r\n\r\n.example-item {\r\n  height: 20px;\r\n}\r\n\r\n\r\n.example-dt {\r\n  height: 30px;\r\n  font-weight: bold;\r\n  font-family: 'Courier New', Courier, monospace;\r\n  font-size: large;\r\n}\r\n\r\n.example-dd {\r\n  height: 30px;\r\n}\r\n\r\n.statOK{\r\n background-color:forestgreen;\r\n}\r\n\r\n.statKO{\r\n  background-color:rgb(182, 13, 27);\r\n }\r\n .switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 45px;\r\n  height: 20px;\r\n  margin-left: 150px;\r\n  margin-top: -50px;\r\n}\r\n\r\n\r\n.disabled {\r\n  color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.enabled {\r\n  color: rgba(0, 0, 0, 255);\r\n}\r\n\r\n.switch input {display:none; background-color: #ccc;}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: -15px;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n   background-color: #ccc;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 0px;\r\n   right: 0px;\r\n  bottom: -3px;\r\n  background-color: #2196F3;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(20px);\r\n  -ms-transform: translateX(20px);\r\n  transform: translateX(20px);\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round {\r\n  border-radius: 20px;\r\n}\r\n\r\n.slider.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n#codeAbo{\r\n  height: 30px;\r\n  font-size: 20px;\r\n }\r\n\r\n.ref{\r\n  height: 30px;\r\n  font-size: 20px;\r\n }\r\n\r\n .mat-chip-list-wrapper {\r\n  flex-wrap: nowrap;\r\n  overflow-x: auto;\r\n}\r\n\r\n.image-clignote  {\r\n  animation-duration: .8s;\r\n  animation-name: clignoter;\r\n  animation-iteration-count: infinite;\r\n  transition: none;\r\n}\r\n@keyframes clignoter {\r\n 0%   { opacity:1; }\r\n 40%   {opacity:0; }\r\n 100% { opacity:1; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
